import { Project } from '../../models';
import { Column, Field, Section } from '../../services/logic-services/models';

export class ProjectHelper {
    static updateOptionsFromProject(project: Project, selectedFields: Field[]): Field[] {
        if (!project?.JSONForms?.Sections || !selectedFields) {
            return selectedFields;
        }

        const projectFieldsMap = new Map<string, Field>();
        ProjectHelper.buildProjectFieldsMap(project.JSONForms.Sections, projectFieldsMap);

        selectedFields.forEach((selectedField: Field) => {
            if (selectedField.dataId) {
                const parentGridField = projectFieldsMap.get(selectedField.dataId);

                if (parentGridField?.FieldType?.options?.columns) {
                    const gridColumn = parentGridField.FieldType.options.columns.find(
                        (col: Column) => col.id === selectedField.id
                    );

                    if (gridColumn) {
                        if (!selectedField.FieldType) {
                            selectedField.FieldType = { id: selectedField.SelectOption } as any;
                        }

                        if (!selectedField.FieldType.options) {
                            selectedField.FieldType.options = {};
                        }

                        if (gridColumn.enum?.length) {
                            selectedField.FieldType.enum = [...gridColumn.enum];
                        }

                        if (gridColumn.format !== undefined) {
                            selectedField.FieldType.options.format = gridColumn.format;
                        }

                        if (gridColumn.decimalPlaces !== undefined) {
                            selectedField.FieldType.options.decimalPlaces = gridColumn.decimalPlaces;
                        }

                        if (gridColumn.description !== undefined) {
                            selectedField.FieldType.options.description = gridColumn.description;
                        }

                        if (gridColumn.richTextFormula !== undefined) {
                            selectedField.FieldType.options.richTextFormula = gridColumn.richTextFormula;
                        }

                        if (gridColumn.pointCategories?.length) {
                            selectedField.FieldType.options.displayText = gridColumn.pointCategories[0]?.name;
                        }

                        if (gridColumn.header !== undefined) {
                            selectedField.Name = gridColumn.header;
                        }

                    }
                }
            }
            else {
                const projectField = projectFieldsMap.get(selectedField.id);

                if (projectField?.FieldType?.options) {
                    selectedField.FieldType.options = { ...projectField.FieldType.options };

                    if (selectedField.FieldType.options.columns?.length && projectField.FieldType.options.columns?.length) {
                        ProjectHelper.updateGridColumnOptions(selectedField.FieldType.options.columns, projectField.FieldType.options.columns);
                    }
                }
            }
        });
        return selectedFields;
    }

    static buildProjectFieldsMap(sections: Section[], fieldsMap: Map<string, Field>): void {
        sections.forEach((section: Section) => {
            if (section.Columns?.length) {
                section.Columns.forEach((column: Column) => {
                    if (column.Fields?.length) {
                        column.Fields.forEach((field: Field) => {
                            fieldsMap.set(field.id, field);
                        });
                    }
                });
            }

            if (section.Sections?.length) {
                ProjectHelper.buildProjectFieldsMap(section.Sections, fieldsMap);
            }
        });
    }

    private static updateGridColumnOptions(selectedColumns: Column[], projectColumns: Column[]): void {
        const projectColumnsMap = new Map<string, Column>();
        projectColumns.forEach((col: Column) => {
            projectColumnsMap.set(col.id, col);
        });

        selectedColumns.forEach((selectedColumn: Column) => {
            const gridColumn = projectColumnsMap.get(selectedColumn.id);

            if (gridColumn) {
                if (gridColumn.header !== undefined) {
                    selectedColumn.header = gridColumn.header;
                }

                if (gridColumn.enum?.length) {
                    selectedColumn.enum = [...gridColumn.enum];
                }

                if (gridColumn.format !== undefined) {
                    selectedColumn.format = gridColumn.format;
                }

                if (gridColumn.decimalPlaces !== undefined) {
                    selectedColumn.decimalPlaces = gridColumn.decimalPlaces;
                }

                if (gridColumn.description !== undefined) {
                    selectedColumn.description = gridColumn.description;
                }

                if (gridColumn.richTextFormula !== undefined) {
                    selectedColumn.richTextFormula = gridColumn.richTextFormula;
                }

                if (gridColumn.pointCategories?.length) {
                    selectedColumn.pointCategories = [...gridColumn.pointCategories];
                }

                if (gridColumn.type !== undefined) {
                    selectedColumn.type = gridColumn.type;
                }
            }
        });
    }
}
